import { Skeleton } from '@ui/Skeleton';

import s from './FeedAside.sss';

export const FeedAsideSkeleton = () => (
  <aside className={s.root}>
    <Skeleton
      width="100px"
      height="30px"
    />
    {new Array(4).fill(null).map((_, i) => (
      <div
        key={i}
        style={{ marginTop: '30px' }}
      >
        <Skeleton
          width="100%"
          height="24px"
        />
        <Skeleton
          width="70%"
          height="14px"
        />
        <Skeleton
          width="70%"
          height="14px"
        />
        <Skeleton
          width="70%"
          height="14px"
        />
      </div>
    ))}
  </aside>
);
